import React, { Component } from 'react'
import { 
  Card, 
  CardHeader, 
  CardBody, 
  Badge, 
  CardFooter, 
  Button,
    Input
} from 'reactstrap'

  import ReactQuill from 'react-quill';
  const modules = {
    formula: true,
    toolbar: [
      [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
      [{size: []}],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}, 
       {'indent': '-1'}, {'indent': '+1'}],
      ['link', 'image', 'video'],
      ['clean'],
      ['formula']
    ]
  }


class TextArea extends Component {
  state = {
    wysiwyg: false,
    preview : true
  }

  toggleWysiwyg = () => this.setState({wysiwyg: !this.state.wysiwyg})
  
  openEditor = () => {
    this.setState(state => ({preview : !state.preview}))
  }
  
  render() {
    const { wysiwyg, preview } = this.state
    const { toggleWysiwyg, openEditor } = this
    const { value,handleValueChange, name } = this.props;
    const text = 'Add your text here ....'

  
    return (
        <React.Fragment>
       {  preview ?  <div 
          dangerouslySetInnerHTML={{__html : value || text}}
          onClick={openEditor}
       />  :  wysiwyg ? <ReactQuill onChange={handleValueChange} name={name} value={value} placeholder={text}  modules={modules} /> :  <Input name={name} value={value} onChange={handleValueChange} placeholder={text} type="textarea" /> }
      { !preview &&  <React.Fragment>
       <Button className="my-2" onClick={toggleWysiwyg}>{`Switch to ${wysiwyg ? 'HTML Editor' : 'WYSIWYG'}`}</Button> {' '}
       <Button className="my-2" onClick={openEditor}>Preview</Button> 
      </React.Fragment> }
                  
       </React.Fragment>
        
    )
  }
}

export default TextArea


// WEBPACK FOOTER //
// ./src/components/Users/Authors/TextArea.js